import { useDispatch } from 'react-redux';

import {
  getPicklists,
  setFilter,
  getFilterCriteria,
  updatePicklist,
  getSummaryCsvResource,
  clearState,
  getProjects,
  getLocations,
  setCreationForm,
  createPicklist
} from 'actions/picklistActions';

export function usePicklistActions() {
  const dispatch = useDispatch();

  const getPicklistsAction = (q) => dispatch(getPicklists(q));

  const createPicklistAction = (data) => dispatch(createPicklist(data));
  const updatePicklistAction = (data, options) => dispatch(updatePicklist(data, options));

  const setFilterAction = (data) => dispatch(setFilter(data));
  const getFilterCriteriaAction = () => dispatch(getFilterCriteria());

  const getSummaryCsvResourceAction = (q) => dispatch(getSummaryCsvResource(q));

  const clearStateAction = () => dispatch(clearState());

  const getCreationFormAction = ({ project, location }) =>
    Promise.all([dispatch(getProjects(project)), dispatch(getLocations(location))]).then(
      ([projects, locations]) => {
        const creationForm = { locations, projects };
        dispatch(setCreationForm(creationForm));
        return creationForm;
      }
    );

  return {
    // Summary Screen
    getPicklistsAction,
    setFilterAction,
    getFilterCriteriaAction,
    getSummaryCsvResourceAction,
    // Edit Screen
    createPicklistAction,
    getCreationFormAction,
    // Common
    updatePicklistAction,
    clearStateAction
  };
}
